/**
 * @(#)2019/6/17.
 * YxTreeSelect，树选择
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import ReactDOM from "react-dom";
import Basics from "./Basics";
import { TreeSelect, Button, Divider } from "antd";
import { get, cloneDeep } from "../../utils";
import request from "../../utils/request";
import { YxComponent, Connection } from "../YxComponent";
import YxHoTreeSelect from "./YxHoTreeSelect";
import YxAction from "../YxAction";
import { isEqual, isFunction, isObject } from "lodash";
import YxText from "../YxText";
import YxModal from "../YxModal";
import YxDynamicForm from "../YxDynamicForm";
const { Icon } = YxText;
import { ITreeSelectPropTypes } from "./IpropType/treeSelectPropType";

/*
 * @param data {array} 用于循环显示下拉列表，必须包含key和label以及children
 * @param requestParam {object} 请求数据
 * @param version {string} 版本号，用于重新请求
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * @param inputParam {object}  作用于 TreeSelect 的参数，继承antd
 * @param inputParam.dropdownRender {object|()=>ReactNode} 对下拉菜单进行自由扩展
 *                  - object: dropdownRender.text :string | ReactNode :新增文本/弹出层标题
 *                            dropdownRender.formParam: object|function(模态关闭函数)=>表单参数: 动态表单参数,参考YxDynamicForm}
 *                  - function: 自定义渲染，返回ReactNode
 * */
//默认props
let defaul = () => {
  return {
    requestParam: null,
    styleParam: {
      size: "default", //大小
      type: "default", //类型
      width: "sm", //宽度
    },
    rules: {
      max: "",
    },
    data: [], //用于循环显示下拉列表，必须包含key和label
    version: "", //版本号
    children: "", //子节点
    inputParam: {},
  };
};
@Connection(defaul)
class YxTreeSelect extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      modalVisible: false,
    };
  }
  async asynDate() {
    let requestParam = get(this.props, "requestParam", false);
    if (requestParam) {
      let { data } = await request(requestParam);
      this.state.data = get(data, "list", []);
      this.setState({});
    }
  }
  async dataList(tmpProps) {
    let version = get(tmpProps, "version", "");
    if (version != this.state.version) {
      this.state.version = version;
      this.asynDate();
    }
  }
  dataHandle(data) {
    let loop = (obj) => {
      obj.map((item) => {
        if (get(item, "label", false) && !get(item, "value", false)) {
          item.value = item.key;
        }
        if (get(item, "label", false) && !get(item, "title", false)) {
          item.title = item.label;
        }
        if (get(item, "children", false)) {
          loop(item.children);
        }
      });
      return obj;
    };
    loop(data);
    return data;
  }

  productionHtml() {
    let tmpProps = { ...this.props };
    let requestParam = get(tmpProps, "requestParam", false);
    if (get(tmpProps, "data", []).length > 0) {
      this.state.data = tmpProps.data;
    } else {
      requestParam && this.dataList(tmpProps);
    }
    tmpProps.inputParam.treeData = this.dataHandle(this.state.data);
    tmpProps.children = <YxHoTreeSelect></YxHoTreeSelect>;

    let classParam = {
      yx_yxSelect_: "styleParam.type",
      yx_yxSelect_size_: "styleParam.size",
      yx_yxInput_width_: "styleParam.width",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );
    tmpProps.inputParam.dropdownRender = this.handleDropdownRender();
    let html = Basics.html(tmpProps);
    return html;
  }

  //处理自定义下拉菜单参数
  handleDropdownRender() {
    let dropdownRender = get(this.props, "inputParam.dropdownRender", null);
    if (!dropdownRender) return null;
    if (isFunction(dropdownRender)) {
      return dropdownRender;
    } else if (isObject(dropdownRender)) {
      let text = get(dropdownRender, "text", "新增");
      return () => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            type="link"
            icon="plus"
            onClick={() => {
              this.setState({ modalVisible: true });
            }}
          >
            {text}
          </Button>
          <Button
            type="link"
            icon="sync"
            onClick={() => {
              this.asynDate();
            }}
          ></Button>
        </div>
      );
    } else {
      return () => defautlRender;
    }
  }
  //渲染新增的动态表单
  renderDropdownModel() {
    let dropdownRender = get(this.props, "inputParam.dropdownRender", null);
    if (isObject(dropdownRender)) {
      let { text, formParam } = dropdownRender;

      let modalProps = {
        title: text || "新增",
        width: "640px",
        zIndex: 9999,
        visible: this.state.modalVisible,
        onClose: () => this.setState({ modalVisible: false }),
      };
      if (isFunction(formParam)) {
        formParam = formParam(modalProps.onClose);
        if (!isObject(formParam)) {
          console.error("函数返回值必须是动态表单配置参数");
        }
      }
      return (
        <YxModal {...modalProps} popupType="drawer">
          {formParam && (
            <YxDynamicForm
              form={this.props.form}
              formParam={formParam}
            ></YxDynamicForm>
          )}
        </YxModal>
      );
    }
  }
  render() {
    return (
      <div className="yx_yxInput_yxTreeSelect">
        {this.productionHtml()}
        {this.renderDropdownModel()}
      </div>
    );
  }
}
YxTreeSelect.propTypes = ITreeSelectPropTypes;
YxTreeSelect.defaultProps = defaul();
export default YxTreeSelect;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxTreeSelect.js